import * as React from "react";

import RootContainer from "./containers/RootContainer";

function App() {
    return (
                <RootContainer />
    );
}

export default App;
